var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sa-page-layout',{attrs:{"btnRefreshVisible":false,"toolbarVisible":false}},[_c('template',{slot:"table-body"},[_c('button-menu-component',{attrs:{"buttonsMenu":_vm.buttonsMenu}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }